<template>
  <a-modal
    title="活动内容素材"
    :visible="visible"
    width="1000px"
    @cancel="visible = false"
  >
    <a-row :gutter="20">
      <a-col :span="12">
        <div class="select-title">
          已选择内容素材（{{ selectMomentList.length }}）:
        </div>
        <a-table
          :pagination="false"
          :columns="columns"
          :dataSource="selectMomentList"
          rowKey="dealerId"
          :scroll="{ y: 400 }"
          :locale="{ emptyText: '暂无数据' }"
          style="min-height: 400px"
        >
          <div slot="materialTitle" slot-scope="row" class="td-box">
            <a-tooltip :title="row.title">
              {{ row.title }}
            </a-tooltip>
          </div>
          <div slot="operate" slot-scope="row" class="td-box">
            <a class="link" @click="cancelSelectMoment(row)">取消选择</a>
          </div>
          <template slot="authors" slot-scope="row">
            <div
              v-for="(item, index) in row.authors"
              :key="index"
              class="author"
            >
              {{ item.authorName }}
            </div>
          </template>
        </a-table>
      </a-col>
      <a-col :span="12">
        <a-row
          type="flex"
          justify="space-between"
          style="align-items: center; margin-bottom: 5px"
        >
          <div class="all-title">内容素材列表:</div>
          <a-input-search
            v-model="form.title"
            class="aft-search"
            style="width: 280px"
            placeholder="输入内容名称搜索"
            allow-clear
            @search="getMomentList(true)"
          ></a-input-search>
        </a-row>
        <a-table
          :pagination="false"
          :columns="columns"
          :dataSource="list"
          :loading="isLoading"
          rowKey="dealerId"
          :scroll="{ y: 400 }"
          :locale="{ emptyText: '暂无数据' }"
          style="min-height: 400px"
        >
          <div
            slot="materialTitle"
            slot-scope="row"
            class="td-box"
            :class="momentIdList.includes(row.id) ? 'selected' : ''"
          >
            <a-tooltip :title="row.title">
              {{ row.title }}
            </a-tooltip>
          </div>
          <div slot="operate" slot-scope="row" class="td-box">
            <a
              v-if="momentIdList.includes(row.id)"
              class="link"
              @click="cancelSelectMoment(row)"
              >取消选择</a
            >
            <a v-else class="link" @click="selectMoment(row)">选择</a>
          </div>
        </a-table>
        <a-row type="flex" justify="end">
          <a-pagination
            v-if="form.total > 0"
            v-model="form.current"
            size="small"
            :pageSize="form.page_size"
            :total="form.total"
            @change="pageChange"
          />
        </a-row>
      </a-col>
    </a-row>
    <div slot="footer" class="modal-footer">
      <a-button class="btn btn1" @click="onClose"> 取消</a-button>
      <a-button class="btn btn2" @click="submit"> 确认 </a-button>
    </div>
  </a-modal>
</template>

<script>
import api from "@/api/marketingActivityList.js";
import { getPrincipalId } from "@/utils/auth";

export default {
  components: {},
  data() {
    return {
      visible: false,
      isLoading: false,

      columns: [
        {
          title: "内容名称",
          align: "left",
          ellipsis: true,
          scopedSlots: { customRender: "materialTitle" },
        },
        {
          title: "操作",
          align: "left",
          width: "100px",
          scopedSlots: { customRender: "operate" },
        },
      ],
      form: {
        principal_id: getPrincipalId(),
        current: 1,
        page_size: 10,
        total: 0,
        title: undefined,
      },
      selectMomentList: [],
      list: [],
    };
  },
  computed: {
    momentIdList() {
      return this.selectMomentList.map((item) => item.id);
    },
  },
  methods: {
    /**
     * 打开内容素材选择弹窗
     * @param {Array} selectMomentList 选择的素材列表
     */
    openModal(selectMomentList) {
      Object.assign(this.$data, this.$options.data());
      this.selectMomentList = JSON.parse(JSON.stringify(selectMomentList));
      this.visible = true;
      this.getMomentList();
    },
    onClose() {
      this.visible = false;
    },
    /**
     * 获取内容素材列表
     */
    getMomentList(isFirst) {
      this.isLoading = true;
      if (isFirst) this.form.current = 1;
      api
        .getMomentList(this.form)
        .then((res) => {
          this.list = res.data.data.list;
          this.form.total = res.data.data.total;
        })
        .finally(() => (this.isLoading = false));
    },
    /**
     * 页数改变
     * @param {number} page 修改的页数
     */
    pageChange(page) {
      this.form.current = page;
      this.getMomentList();
    },
    selectMoment(row) {
      this.selectMomentList.push({ id: row.id, title: row.title });
    },
    cancelSelectMoment(row) {
      const index = this.momentIdList.findIndex((id) => id === row.id);
      this.selectMomentList.splice(index, 1);
    },
    submit() {
      this.$emit("success", this.selectMomentList);
      this.onClose();
    },
  },
  created() {},
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/_handle.scss";
::v-deep .ant-modal-header {
  padding: 24px;
  border-bottom: none;
}
::v-deep .ant-modal-close-x {
  width: 70px;
  height: 70px;
  line-height: 70px;
}
::v-deep .ant-modal-body {
  padding: 0 24px;
}
::v-deep .ant-modal-footer {
  padding: 20px 24px;
  border-top: none;
}

// 表格
::v-deep .ant-table-header,
::v-deep
  .ant-table-fixed-header
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body {
  background: #1a1d26;
}
::v-deep .ant-table-header {
  overflow-y: hidden !important;
}
::v-deep .ant-table-thead > tr > th {
  padding: 10px;
  background: #242832;
  color: rgba(255, 255, 255, 0.88);
  font-size: 12px;
  border-bottom-color: rgba(255, 255, 255, 0.12);
}
::v-deep .ant-table-tbody > tr > td {
  color: rgba(255, 255, 255, 0.88);
  border-bottom-color: rgba(255, 255, 255, 0.12);
  padding: 0;
  height: 1px;
}
::v-deep .ant-table-placeholder {
  background: #1a1d26;
  border-color: rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.88);
}

// 分页
::v-deep .ant-pagination-item a,
::v-deep .ant-pagination-disabled a,
::v-deep .ant-pagination-disabled:hover a,
::v-deep .ant-pagination-disabled:focus a,
::v-deep .ant-pagination-disabled .ant-pagination-item-link,
::v-deep .ant-pagination-disabled:hover .ant-pagination-item-link,
::v-deep .ant-pagination-disabled:focus .ant-pagination-item-link,
::v-deep .ant-pagination-prev a,
::v-deep .ant-pagination-next a,
::v-deep
  .ant-pagination-jump-prev
  .ant-pagination-item-container
  .ant-pagination-item-ellipsis,
::v-deep
  .ant-pagination-jump-next
  .ant-pagination-item-container
  .ant-pagination-item-ellipsis {
  color: #9aa5be;
}
::v-deep .ant-pagination-prev:focus .ant-pagination-item-link,
::v-deep .ant-pagination-next:focus .ant-pagination-item-link,
::v-deep .ant-pagination-prev:hover .ant-pagination-item-link,
::v-deep .ant-pagination-next:hover .ant-pagination-item-link,
::v-deep
  .ant-pagination-jump-prev
  .ant-pagination-item-container
  .ant-pagination-item-link-icon,
::v-deep
  .ant-pagination-jump-next
  .ant-pagination-item-container
  .ant-pagination-item-link-icon {
  color: #ffca5c;
}
::v-deep .ant-pagination-item-active {
  border: 1px solid transparent;
  background: none;
  a {
    color: #ffca5c;
  }
}
::v-deep .aft-search.ant-input-search.ant-input-affix-wrapper {
  > input {
    border: none !important;
    border-radius: 8px;
    outline: none !important;
    box-shadow: none;
    background: #242832 !important;
    color: rgba(255, 255, 255, 0.88);
  }
  .ant-input-search-icon {
    color: rgba(255, 255, 255, 0.88);
  }
  .ant-input-clear-icon {
    color: rgba(255, 255, 255, 0.88);
  }
  > input:focus {
    color: rgba(255, 255, 255, 0.88);
    background: #242832;
  }
}

.td-box {
  padding: 10px;
  height: 100%;
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;
  & > span {
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    white-space: nowrap;
  }
  &.selected {
    color: rgba(255, 255, 255, 0.45);
  }
}

.select-title {
  height: 32px;
  line-height: 32px;
  color: #ffca5c;
  margin-bottom: 5px;
}

.all-title {
  color: rgba(255, 255, 255, 0.88);
  margin-bottom: 5px;
}

.link {
  color: #ffcc55;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;

  &.l-8 {
    margin-left: 8px;
  }
  &.cancel {
    color: rgba(255, 255, 255, 0.45);
  }
}

.btn {
  height: 40px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  margin-left: 8px;

  &.btn1 {
    background: #2b2f3b;
    border-color: #2b2f3b;
    color: rgba(255, 255, 255, 0.65);
  }

  &.btn2 {
    background: #ffca5b;
    border-color: #ffca5b;
    color: #000000;
  }
}
</style>
